import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=af2c9cda&"
import script from "./transactions.vue?vue&type=script&lang=ts&"
export * from "./transactions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports